import { useClassName } from '@/styles/Tabs';
import { GenericComponentFactory } from 'base/components/GenericComponent';

const GenericComponent = GenericComponentFactory({ useClassName });

const Base = GenericComponent({ as: 'ul' });
const Tab = GenericComponent({ as: 'li', styles: { key: 'tab' } });

export const Tabs = Object.assign(Base, { Tab });
